<template>
  <div class="home-category" :class="{'is-loading': loading}" v-if="loading || (categories && categories.length > 0)">
    <div class="loading-container" v-if="loading">
      <i class="loading-icon"></i>
    </div>
    <ul class="category-list" v-else>
      <li
        v-for="(item, index) in categories"
        :key="item.categoryId || index"
        class="category-item"
        :class="{'has-children': item.children && item.children.length}"
        @click="goCategory(item.categoryId)"
      >
        <span class="category-name">{{item.categoryName}}</span>
        <i class="arrow-right" v-if="item.children && item.children.length"></i>
        <div class="sub-menu" v-if="item.children && item.children.length > 0">
          <div
            v-for="child in item.children"
            :key="child.categoryId"
            class="sub-item-row"
            :class="{'has-nested': child.children && child.children.length}"
          >
            <a
              class="sub-item-link"
              @click.stop="goCategory(item.categoryId, child.categoryId)"
            >{{child.categoryName}}</a>
            <i class="arrow-right" v-if="child.children && child.children.length"></i>
            <div class="sub-menu nested" v-if="child.children && child.children.length > 0">
              <div
                v-for="sub in child.children"
                :key="sub.categoryId"
                class="sub-item-row"
                :class="{'has-nested': sub.children && sub.children.length}"
              >
                <a
                  class="sub-item-link"
                  @click.stop="goCategory(child.categoryId, sub.categoryId)"
                >{{sub.categoryName}}</a>
                <i class="arrow-right" v-if="sub.children && sub.children.length"></i>
                <div class="sub-menu nested" v-if="sub.children && sub.children.length > 0">
                  <div
                    v-for="sub2 in sub.children"
                    :key="sub2.categoryId"
                    class="sub-item-row"
                    :class="{'has-nested': sub2.children && sub2.children.length}"
                  >
                    <a
                      class="sub-item-link"
                      @click.stop="goCategory(sub.categoryId, sub2.categoryId)"
                    >{{sub2.categoryName}}</a>
                    <i class="arrow-right" v-if="sub2.children && sub2.children.length"></i>
                    <div class="sub-menu nested" v-if="sub2.children && sub2.children.length > 0">
                      <div
                        v-for="sub3 in sub2.children"
                        :key="sub3.categoryId"
                        class="sub-item-row"
                      >
                        <a
                          class="sub-item-link"
                          @click.stop="goCategory(sub2.categoryId, sub3.categoryId)"
                        >{{sub3.categoryName}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HomeCategory',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  methods: {
    goCategory (categoryId, childCategoryId) {
      const finalId = childCategoryId || categoryId
      this.$emit('select', { categoryId, childCategoryId })
      this.$router.push({
        name: 'Course',
        params: { target: this.$store.state.sessionTarget },
        query: { categoryId: finalId }
      })
    }
  }
}
</script>

<style lang="scss">
.home-category {
  padding: 12px 0;
  min-width: 160px;

  &.is-loading {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-container {
    text-align: center;
    .loading-icon {
      display: inline-block;
      background: url(../assets/img/loading.gif) no-repeat;
      background-size: 100%;
      width: 40px;
      height: 40px;
    }
  }

  .category-list {
    list-style: none;
    margin: 0;
    padding: 0;

    .category-item {
      position: relative;
      padding: 10px 16px;
      cursor: pointer;
      font-size: 15px;
      color: #333;
      transition: all 0.2s;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        color: #FD3374;
        background: #FFF5F7;

        > .arrow-right {
          border-left-color: #FD3374;
        }
      }

      .category-name {
        flex: 1;
      }

      .arrow-right {
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 4px 0 4px 5px;
        border-color: transparent transparent transparent #999;
        margin-left: 6px;
        flex-shrink: 0;
      }

      .sub-menu {
        display: none;
        position: absolute;
        left: 100%;
        top: -8px;
        background: #fff;
        border: 1px solid #F0F0F0;
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.1);
        min-width: 150px;
        padding: 8px 0;
        z-index: 100;
      }

      &:hover > .sub-menu {
        display: block;
      }
    }
  }

  // 子级通用样式
  .sub-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .sub-item-link {
      display: block;
      padding: 8px 12px;
      font-size: 14px;
      color: #666;
      text-decoration: none;
      white-space: nowrap;
      flex: 1;
      transition: all 0.15s;
      cursor: pointer;

      &:hover {
        color: #FD3374;
        background: #FFF5F7;
      }
    }

    .arrow-right {
      display: inline-block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4px 0 4px 5px;
      border-color: transparent transparent transparent #ccc;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .sub-menu {
      display: none;

      &.nested {
        position: absolute;
        left: 100%;
        top: -8px;
        background: #fff;
        border: 1px solid #F0F0F0;
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.1);
        min-width: 150px;
        padding: 8px 0;
        z-index: 100;
      }
    }

    // 只影响直接子级箭头
    &:hover > .sub-menu {
      display: block;
    }

    &:hover > .arrow-right {
      border-left-color: #FD3374;
    }
  }
}
</style>
